import React from "react";
import LoaderGif from "../styles/images/loader_nw.gif";
import {useActions} from "../actions";
import * as GiftorAct from "../actions/giftor";
import {sleep} from "../utils/commonUtils";
import {getQueryStringValue} from "../utils/queryString";


const AfterCompleteDocSign = () => {
    const giftorAct = useActions(GiftorAct);
    let envelopeId: string = "";
    let searchParams = window.location.search;
    let event_status: any;
    if (searchParams) {
        event_status = getQueryStringValue("event", searchParams) || "";
        envelopeId = getQueryStringValue("envelopeId", searchParams) || "";
    }


    React.useEffect(() => {
        if (event_status === "signing_complete") {
            // eslint-disable-next-line no-restricted-globals
            let backbtn: any = parent.document.getElementById("backbtn");
            backbtn && backbtn.click()
        }

        if (envelopeId) {
            // send email after kid invite approved by admin
            giftorAct.inviteAndEmailAfterDocApprove({envelopeId});

            sleep(5000).then(() => {
                // eslint-disable-next-line no-restricted-globals
                let btnViewComplete: any = parent.document.getElementById("adminclosebtn");
                btnViewComplete && btnViewComplete.click();
            })
        }

    }, []);


    return (
            <div className="commonLoaderWrap textCenter">
                <img src={LoaderGif} alt='Loading...'/>
            </div>
    );
};

export default AfterCompleteDocSign;